import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TENANT_ROLE_COLORS, TENANT_ROLE_ORDER, type TenantRoleType } from '@/constants/tenantRoles';

export interface TenantRoleOption {
  value: TenantRoleType;
  label: string;
  description: string;
  color: string;
}

/**
 * Translated tenant role options (label, description, tag colour) for selects, radios and tags.
 * @param roles - Roles to include, in display order; defaults to all tenant roles.
 */
export function useTenantRoleOptions(roles: readonly TenantRoleType[] = TENANT_ROLE_ORDER): TenantRoleOption[] {
  const { t } = useTranslation('common');

  return useMemo(
    () =>
      roles.map((role) => ({
        value: role,
        label: t(`tenantRoles.${role}.label`),
        description: t(`tenantRoles.${role}.description`),
        color: TENANT_ROLE_COLORS[role]
      })),
    [roles, t]
  );
}
